<template>
  <AcCard class="flex flex-col border border-white">
    <div
        class="grid-flow-row lg:grid lg:auto-rows-max lg:grid-cols-[1fr,400px]"
    >
      <div
          class="row-span-1 flex w-full flex-col space-y-4 border border-b-2 border-white bg-blue px-4 pb-3 pt-2"
      >
        <div v-if="shouldSwitchHeadingTag" class="text-2xl font-extrabold text-white">
            <PersonalPageLink :agency="agency">{{ agencyName }}</PersonalPageLink>
        </div>
        <h2 v-else class="text-2xl font-extrabold text-white">
            <PersonalPageLink :agency="agency">{{ agencyName }}</PersonalPageLink>
        </h2>
      </div>

      <div
          class="row-span-1 hidden w-full flex-col space-y-4 border border-b-2 border-white bg-blue px-4 py-3 lg:flex"
      >
        <p class="text-xl font-extrabold text-white">
          <template v-if="userType === 'emp'">
            Employer Contact Options
          </template>
          <template v-else-if="userType === 'cnd'">
            Candidate Contact Options
          </template>
          <template v-else>Contact Options</template>
        </p>
      </div>

      <div class="row-span-1 w-full bg-blue-10 md:p-4 p-4 pb-6 text-grey-90">
        <p class="pb-4 text-base text-grey-90">
            {{ agency.strapline }}
            <div v-if="!agency.FAL" class="pt-3">
                <PersonalPageLink :agency="agency" class="text-base text-blue-50">
                        View detailed information
                        <IconChevronRight class="inline h-4 w-4"/>
                </PersonalPageLink>
            </div>
        </p>

        <div class=""> <!-- md:pb-4-->
          <div class="text-grey-80 grid grid-cols-advert-info gap-x-5 gap-y-3 text-xl">
            <AgencyAdvertStrapline v-if="!agency.FAL" :agency="agency"/>
            <AgencyAdvertAddress :agency="agency"/>
          </div>
        </div>

        <AgencyAdvertLastUpdated :agency="agency" />

      </div>

      <AgencyAdvertContactOptions
          :agency="agency"
          :user-type="userType"
          @contactFormSelect="
          (event) => $emit('contactOpen', { form: event.form, type: event.type, social: event.social, agency })
        "
          @moreInfoSelect="onMoreInfoSelect"
      />
    </div>
  </AcCard>
</template>

<script>
import AcCard from 'Components/AcCard.vue';
import IconChevronRight from 'Components/Icons/IconChevronRight';
import AgencyAdvertAddress from 'Components/AgencyAdvertAddress.vue';
import AgencyAdvertContactOptions from 'Components/AgencyAdvertContactOptions.vue';
import AgencyAdvertStrapline from 'Components/AgencyAdvertStrapline.vue';
import AgencyAdvertLastUpdated from 'Components/AgencyAdvertLastUpdated.vue';
import PersonalPageLink from 'Components/PersonalPageLink.vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import { VueElement } from 'vue';

export default {
  name: 'AgencyAdvert',
  components: {
    AgencyAdvertStrapline,
    AgencyAdvertContactOptions,
    AgencyAdvertAddress,
    AgencyAdvertLastUpdated,
    IconChevronRight,
    AcCard,
    PersonalPageLink,
  },
  props: {
    agency: {
      type: Object,
      default: function () {
        return {};
      },
    },
    userType: {
      type: String,
      validator (value) {
        return ['emp', 'cnd', 'neither'].includes(value);
      },
      default: 'neither',
    },
  },
  methods: {
    // ...mapActions('search', ['shouldSwitchHeadingTagForPath']),
    onMoreInfoSelect () {
        let url = this.url_to_object(this.makePersonalPageURL(this.agency));
        url.query.set('search_id', this.searchId);
        this.link_to(url);
    },
    isFAL() {
        return (this.agency.FAL == 'Y' || this.agency.FAL === true) ? true : false;
    },
  },
  computed: {
    ...mapState('search', ['parameters', 'searchId']),
    ...mapGetters('agency', ['personalPageURL']),
    ...mapGetters('search', ['makePersonalPageURL', 'shouldSwitchHeadingTagForPath']),
    shouldSwitchHeadingTag() {
        return this.shouldSwitchHeadingTagForPath(this.$route.path);
    },
    agencyName() {
        // this routine can be massaged as appropriate, don't revert to direct
        // access to the object
        let n = this.agency.Name;        
        if (this.isDevMode() && this.isFAL()) {
            n = n + " (FAL)";
        }
        return n;
    }
  },
};
</script>
